export function cairnReferenceFromHash(hashValue) {
	const reference = decodeURIComponent((hashValue || "").replace(/^#/, "").trim());

	if (reference.length === 0) {
		return undefined;
	}

	if (reference.startsWith("cairn/") === true) {
		return reference.slice("cairn/".length);
	}

	if (reference.startsWith("cairn:") === true) {
		return reference.slice("cairn:".length);
	}

	if (reference.startsWith("cairn=") === true) {
		return reference.slice("cairn=".length);
	}

	return reference;
}
